export const SET_PROMO_OFFER_ENABLED = 'SET_PROMO_OFFER_ENABLED';

export type PromoOfferEnabledState = boolean;
